module.exports = __webpack_public_path__ + "img/deskshelf26.e9141a1d.jpg";